module.exports = __webpack_public_path__ + "static/img/13.c8be4d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/13.png
// module id = 40Ne
// module chunks = 1